﻿
((window) => {
    angular.module("fliptoWeb")
        .constant("routes",
        {
            advocacy: "/advocacy",
            blog: "/blog",
            about: "/about",
            customers: "/customers",
            features: "/features",
            goingLive: "/features/going-live",
            home: "/home",
            management: "/features/management",
            news: "/news",
            tour: "/tour",
            partners: "/partners",
            photoAdvocacy: "/features/photo-advocacy",
            poststay: "/features/poststay-advocacy",
            prestay: "/features/prestay-advocacy",
            superchargers: "/features/site-superchargers",
            terms: "/terms",
            security: "/security",
            accessibility: "/accessibility",
            privacy: "/privacy",
            sla: "/sla",
            msa: "/msa",
            msaPartner: "/msa-partner",
            error404: "/404",
            generalError: "/oops",
            fuel: "/fuel-reimagined-marketing"
            })
        .config([
            "$locationProvider", "$stateProvider", "$urlRouterProvider", "routes", "config",
            ($locationProvider, $stateProvider, $urlRouterProvider, routes, config) => {

                $locationProvider.html5Mode(true).hashPrefix("!");

                if (config.isIntro) {
                    $urlRouterProvider.otherwise("/by");

                    $urlRouterProvider.when(/^\/(intro-jackrabbit|jackrabbit)/i, '/dmo/by');

                    $stateProvider
                        .state("intro-dmo",
                        {
                            url: "/dmo/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro-dmo",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => "dmo"],
                                representatives: ["representatives", representatives => representatives("dmo")]
                            },
                            title: "Flip.to | Intro"
                        })
                        .state("intro-vr",
                        {
                            url: "/vr/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro-vr",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => "vr"],
                                representatives: ["representatives", representatives => representatives("vr")]
                            },
                            title: "Flip.to | Intro"
                        })
                        /* Reroute vr experience kissimmee intro page to hotel intro page */
                        .state("intro-vr-experiencekissimmee",
                        {
                            url: "/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => null],
                                representatives: ["representatives", representatives => representatives("intro")]
                            },
                            title: "Flip.to | Intro"
                        })
                        .state("intro-benchmark",
                        {
                            url: "/benchmark/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro-benchmark",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => "benchmark"],
                                representatives: ["representatives", representatives => representatives("benchmark")]
                            },
                            title: "Flip.to | Intro"
                        })
                        .state("intro-milemarker630",
                        {
                            url: "/milemarker630/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro-milemarker630",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => "milemarker630"],
                                representatives: ["representatives", representatives => representatives("milemarker630")]
                            },
                            title: "Flip.to | Intro"
                        })
                        /* Reroute experience kissimmee intro page to hotel intro page */
                        .state("intro-experiencekissimmee",
                        {
                            url: "/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => null],
                                representatives: ["representatives", representatives => representatives("intro")]
                            },
                            title: "Flip.to | Intro"
                        })
                        .state("intro-fuel",
                        {
                            url: "/fuel/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro-fuel",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => "fuel"],
                                representatives: ["representatives", representatives => representatives("fuel")]
                            },
                            title: "Flip.to | Intro"
                        })
                        /* Reroute visit florida intro page to hotel intro page */
                        .state("intro-visitflorida",
                        {
                            url: "/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => null],
                                representatives: ["representatives", representatives => representatives("intro")]
                            },
                            title: "Flip.to | Intro"
                        })
                        .state("intro-intercoastalnet",
                        {
                            url: "/intercoastalnet/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro-intercoastalnet",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => "intercoastalnet"],
                                representatives: ["representatives", representatives => representatives("intercoastalnet")]
                            },
                            title: "Flip.to | Intro"
                        })
                        .state("intro-resortdataprocessing",
                        {
                            url: "/resortdataprocessing/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro-resortdataprocessing",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => "resortdataprocessing"],
                                representatives: ["representatives", representatives => representatives("resortdataprocessing")]
                            },
                            title: "Flip.to | Intro"
                        })
                        .state("intro-hotel",
                        {
                            url: "/by{name:(?:/[^/]+)?}{slug:(?:/[^/]+)?/?}",
                            templateUrl: "/intro",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.name)
                                            ? $stateParams.name.substring(1)
                                            : null;
                                    }
                                ],
                                slug: [
                                    "$stateParams", function ($stateParams) {
                                        return angular.isDefined($stateParams.slug)
                                            ? $stateParams.slug.substring(1)
                                            : null;
                                    }
                                ],
                                introType: [() => null],
                                representatives: ["representatives", representatives => representatives("intro")]
                            },
                            title: "Flip.to | Intro"
                        })
                        .state("intro-random",
                        {
                            url: "/by/",
                            templateUrl: "/intro",
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                name: [() => null],
                                slug: [() => null],
                                introType: [() => null],
                                representatives: ["representatives", representatives => representatives("intro")]
                            },
                            title: "Flip.to | Intro"
                        })
                        .state("intro-personalized",
                        {
                            url: "/intro/{website}{person:(?:/[^/]+)?}",
                            templateUrl: function($stateParams) {
                                return `/intro/${$stateParams.website}${!!$stateParams.person ? "/" + $stateParams.person : ""}`;
                            },
                            /*todo: switch to personalized controller when we know what to do*/
                            controller: "IntroCtrl",
                            controllerAs: "vm",
                            resolve: {
                                /*this will always fallback to debi because we dont have all sales integrated yet*/
                                name: ["contacts", (contacts) => contacts.emailsToShortNames[window["PersonalizedIntroInfo"].contactPerson] || 'debi'],
                                slug: [() => window["PersonalizedIntroInfo"].hotelName],
                                introType: [() => null],
                                representatives: ["representatives", "contacts", (representatives, contacts) =>
                                    new Representatives([contacts.emailsToShortNames[window["PersonalizedIntroInfo"].contactPerson] || 'debi'],
                                        ['debi'])]
                            },
                            title: "Flip.to | Intro"
                        });
                }
                else {

                    //All other routes invalid
                    $urlRouterProvider.otherwise(routes.error404);


                    $stateProvider
                        .state("/",
                        {
                            url: "/",
                            templateUrl: routes.home,
                            controller: "HomeCtrl as vm",
                            title: "Flip.to | The most trusted way to earn new guests"
                        })
                        .state(routes.advocacy,
                        {
                            url: routes.advocacy,
                            templateUrl: routes.advocacy,
                            controller: "AdvocacyCtrl as vm",
                            title: "The Flip.to Advocacy Dept."
                        })
                        .state(routes.news,
                        {
                            url: routes.news,
                            templateUrl: routes.news + window.location.search,
                            controller: "NewsCtrl as vm",
                            title: "Flip.to News"
                        })
                        .state(routes.news + "/article",
                        {
                            url: routes.news + "/:articleSlug",
                            templateUrl: (params) => {
                                //Angular/DotNet is doing something weird with template caching and
                                //pushing a cached full view (not partial) with html head & script references, etc
                                //busting the cache every time route is requested fixes the problem
                                //mostly seen going from the site to an external site and hitting the back button

                                var qs = window.location.search || "?";
                                qs += "&v=" + getRandomCacheNumber();

                                return routes.news + "/" + params.articleSlug + qs;
                            },
                            controller: "ArticleCtrl as vm",
                            title: "Flip.to News"
                        })
                        .state(routes.news + "/category/:categorySlug",
                        {
                            url: routes.news + "/category/:categorySlug",
                            templateUrl: (params) => {
                                return "/news/category/" + params.categorySlug + window.location.search;
                            },
                            controller: "NewsCtrl as vm",
                            title: "Flip.to News"
                        })
                        .state(routes.blog,
                        {
                            url: routes.blog,
                            templateUrl: routes.blog + window.location.search,
                            controller: "BlogCtrl as vm",
                            title: "The Flip.to Blog"
                        })
                        .state(routes.blog + "/article",
                        {
                            url: routes.blog + "/:articleSlug",
                            templateUrl: (params) => {
                                var qs = window.location.search || "?";
                                qs += "&v=" + getRandomCacheNumber();

                                return routes.blog + "/" + params.articleSlug + qs;
                            },
                            controller: "BlogArticleCtrl as vm",
                            title: "The Flip.to Blog"
                        })
                        .state(routes.blog + "/category/:categorySlug",
                        {
                            url: routes.blog + "/category/:categorySlug",
                            templateUrl: (params) => {
                                return "/blog/category/" + params.categorySlug + window.location.search;
                            },
                            controller: "BlogCtrl as vm",
                            title: "The Flip.to Blog"
                        })
                        .state(routes.about,
                        {
                            url: routes.about,
                            templateUrl: routes.about,
                            controller: "AboutCtrl as vm",
                            title: "About Flip.to"
                        })
                        .state("customers",
                        {
                            url: "/customers",
                            templateUrl: "/customers",
                            controller: "CustomersCtrl as vm",
                            title: "Flip.to Customers",
                            resolve: {
                                tab: () => "hotels"
                            }
                        })
                        .state("customersWithTab",
                        {
                            url: "/customers/{tab}",
                            templateUrl: "/customers",
                            controller: "CustomersCtrl as vm",
                            title: "Flip.to Customers",
                            resolve: {
                                tab: ["$stateParams", ($stateParams) => {
                                    if (["hotels", "resorts", "vr", "dmo"].indexOf($stateParams.tab) === -1) return "hotels";
                                    return $stateParams.tab;
                                }]
                            }
                        })
                        .state(routes.features,
                        {
                            url: routes.features,
                            templateUrl: routes.features,
                            controller: "FeaturesCtrl as vm",
                            title: "Flip.to Features"
                        })
                        .state(routes.goingLive,
                        {
                            url: routes.goingLive,
                            templateUrl: routes.goingLive,
                            controller: "GoingLiveCtrl as vm",
                            title: "Going Live with Flip.to"
                        })
                        .state(routes.home,
                        {
                            url: routes.home,
                            templateUrl: routes.home,
                            controller: "HomeCtrl as vm",
                            title: "Flip.to | The most trusted way to earn new guests"
                        })
                        .state(routes.management,
                        {
                            url: routes.management,
                            templateUrl: routes.management,
                            controller: "ManagementCtrl as vm",
                            title: "Managing Flip.to"
                        })
                        .state(routes.partners,
                        {
                            url: routes.partners,
                            templateUrl: routes.partners,
                            controller: "PartnersCtrl as vm",
                            title: "Flip.to Partners"
                        })
                        .state(routes.photoAdvocacy,
                        {
                            url: routes.photoAdvocacy,
                            templateUrl: routes.photoAdvocacy,
                            controller: "PhotoAdvocacyCtrl as vm",
                            title: "Flip.to Photo Advocacy"
                        })
                        .state(routes.poststay,
                        {
                            url: routes.poststay,
                            templateUrl: routes.poststay,
                            controller: "PoststayCtrl as vm",
                            title: "Flip.to Post-stay Advocacy"
                        })
                        .state(routes.prestay,
                        {
                            url: routes.prestay,
                            templateUrl: routes.prestay,
                            controller: "PrestayCtrl as vm",
                            title: "Flip.to Pre-stay Advocacy"
                        })
                        .state(routes.superchargers,
                        {
                            url: routes.superchargers,
                            templateUrl: routes.superchargers,
                            controller: "SuperchargersCtrl as vm",
                            title: "Flip.to Site Superchargers"
                        })
                        .state(routes.terms,
                        {
                            url: routes.terms,
                            templateUrl: routes.terms,
                            title: "Flip.to | Terms & Conditions"
                        })
                        .state(routes.security,
                        {
                            url: routes.security,
                            templateUrl: routes.security,
                            title: "Flip.to | Security Statement"
                        })
                        .state(routes.accessibility,
                        {
                            url: routes.accessibility,
                            templateUrl: routes.accessibility,
                            title: "Flip.to | Accessibility Statement"
                        })
                        .state(routes.privacy,
                        {
                            url: routes.privacy,
                            templateUrl: routes.privacy,
                            title: "Flip.to | Privacy Policy"
                        })
                        .state(routes.sla,
                            {
                                url: routes.sla,
                                templateUrl: routes.sla,
                                title: "Flip.to | Service Level Agreement"
                            })
                        .state(routes.msa,
                        {
                            url: routes.msa,
                            templateUrl: routes.msa,
                            title: "Flip.to | Master Subscription Agreement"
                        })
                        .state(routes.msa + "/version",
                        {
                            url: routes.msa + "/:version",
                            templateUrl: (params) => {
                                return "/msa/" + params.version + window.location.search;
                            },
                            title: "Flip.to | Historical Master Subscription Agreement"
                        })
                        .state(routes.msaPartner,
                        {
                            url: routes.msaPartner,
                            templateUrl: routes.msaPartner,
                            title: "Flip.to Partner | Master Subscription Agreement"
                        })
                        .state(routes.msaPartner + "/version",
                        {
                            url: routes.msaPartner + "/:version",
                            templateUrl: (params) => {
                                return "/msa-partner/" + params.version + window.location.search;
                            },
                            title: "Flip.to | Historical Master Subscription Agreement"
                        })
                        .state(routes.tour,
                        {
                            url: routes.tour,
                            templateUrl: routes.tour,
                            controller: "TourCtrl as vm",
                            title: "Flip.to | Tour"
                        })
                        .state(routes.error404,
                        {
                            url: routes.error404,
                            templateUrl: routes.error404,
                            title: "Flip.to | 404: File not found"
                        })
                        .state(routes.generalError,
                        {
                            url: routes.generalError,
                            templateUrl: routes.generalError,
                            title: "Flip.to | General Error"
                        })
                        .state(routes.fuel,
                        {
                            url: routes.fuel,
                            templateUrl: routes.fuel,
                            controller: "WebisodeFuelCtrl as vm",
                            title: "Flip.to | Free weekly webisodes from Flip.to + Fuel Travel"
                        })
                }


                function getRandomCacheNumber() {
                    var max = 9999999,
                        min = 1000000;
                    return Math.random() * (max - min) + min;
                }
            }
        ]);
})(window)